"use client";

import Button, { IButtonProps } from "@template/components/Button";
import { useEffect, useState } from "react";
import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks.ts";
import { getTldPrices } from "@/redux/slices/store/thunks/getTldPrices.ts";
import * as S from "./styles.ts";
import { H2 } from "@template/components";
import Card from "@template/blocks/domain/DomainPricingCards/Card";
import { getTlds } from "@/redux/slices/store/thunks/getTlds.ts";

type TldProps = {
  tld: number;
};

type DomainPricingCardsProps = {
  button?: IButtonProps;
  label?: string;
  tlds?: TldProps[];
  us_tlds?: TldProps[];
};

const DomainPricingCards = ({
                              tlds = [],
                              us_tlds = [],
                              button,
                              label,
                            }: DomainPricingCardsProps) => {
  const availableTlds = useTypedSelector((state) => state.store.tlds.tlds);

  const dispatch = useTypedDispatch();
  const siteVersion = useTypedSelector((state) => state.store.site_version);
  const isUs = siteVersion?.currency === "USD";

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (mounted) return;

    setMounted(true);

    const tldsToSearch = isUs && us_tlds?.length ? us_tlds : tlds;

    dispatch(
      getTldPrices({
        ids: tldsToSearch.map(({ tld }) => tld),
      })
    );
  }, []);

  useEffect(() => {
    if (!availableTlds.loaded) {
      dispatch(getTlds());
    }
  }, [availableTlds.loaded]);

  return (
    <S.Wrapper>
      <S.Container>
        {(button?.children || label) && (
          <S.Header>
            {label && <H2>{label}</H2>}
            {button?.children && <Button {...button} />}
          </S.Header>
        )}
        <S.Cards>
          {tlds.map(({ tld }, i) => (
            <Card
              id={tld}
              key={i}
            />
          ))}
        </S.Cards>
      </S.Container>
    </S.Wrapper>
  );
};

export default DomainPricingCards;
